module.exports = __webpack_public_path__ + "static/media/kotigo.a2178138.jpg";